import { getConversionKeyForLocation } from '~/config/googleAdsConversions';
import type { DataLayerEvent } from '~/types/tracking';

function pushDataLayerEvent(event: DataLayerEvent) {
    if (!import.meta.client) {
        return;
    }

    window.dataLayer?.push(event);
}

export function trackVirtualPageView(pagePath: string, pageTitle: string) {
    pushDataLayerEvent({
        event: 'nuxt_route',
        page_path: pagePath,
        page_title: pageTitle,
        page_location: window.location.href
    });
}

export function trackContactEmailClick(linkUrl: string, linkText = '') {
    pushDataLayerEvent({
        event: 'contact_email_click',
        link_url: linkUrl,
        link_text: linkText,
        page_path: window.location.pathname
    });
}

export function trackContactPhoneClick(linkUrl: string, linkText = '') {
    pushDataLayerEvent({
        event: 'contact_phone_click',
        link_url: linkUrl,
        link_text: linkText,
        page_path: window.location.pathname
    });
}

export function trackAppointmentBooked(locationSlug: string) {
    const conversionKey = getConversionKeyForLocation(locationSlug);

    if (!conversionKey) {
        if (import.meta.dev) {
            console.warn(`No Google Ads conversion mapping for location slug: ${locationSlug}`);
        }

        return;
    }

    pushDataLayerEvent({
        event: 'appointment_booked',
        location_slug: locationSlug,
        conversion_key: conversionKey
    });
}
